import { render, staticRenderFns } from "./PharmacistsInfoTable.vue?vue&type=template&id=57e56d06&"
import script from "./PharmacistsInfoTable.vue?vue&type=script&lang=js&"
export * from "./PharmacistsInfoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports